import { IntlShape } from 'react-intl';
import { TaskAssignmentTypeDTO } from '../api/dto';
import { TaskAssignmentPreciseDTO } from '../api/task';
import { getRoleUrl } from '../routes/externalRoutes';
import { translateTaskAssignment } from './language';

interface LabelPart {
    value: string;
    title?: string;
    url?: string;
}

export const getAssignmentLabel = (assignment: TaskAssignmentPreciseDTO | null, intl: IntlShape): LabelPart[] => {
    if (assignment === null) {
        return [
            {
                value: intl.formatMessage({ id: 'document.task.addedAssignees' }),
            },
        ];
    }
    switch (assignment.type) {
        case TaskAssignmentTypeDTO.PERSON:
            // TODO: isn't this label always defined?
            return [
                {
                    value: assignment.label ? translateTaskAssignment(assignment.label, intl.locale).label : 'Person', // TODO translate
                },
            ];
        case TaskAssignmentTypeDTO.EGROUP:
            // TODO label
            return [
                {
                    value: assignment.egroup,
                },
            ];
        case TaskAssignmentTypeDTO.ROLE:
            return [
                {
                    value: assignment.label
                        ? translateTaskAssignment(assignment.label, intl.locale).label
                        : assignment.role,
                    url: !assignment.isImpactRole ? getRoleUrl(assignment.role) : undefined,
                },
            ];
        case TaskAssignmentTypeDTO.CUSTOM:
            return [
                {
                    value: translateTaskAssignment(assignment.custom, intl.locale).label,
                },
            ];
    }
};
